<script>
  import { createEventDispatcher } from "svelte";
  let container;
  export let map;

  const dispatch = createEventDispatcher();

  export let zoom;
  export let center;

  import { onMount } from "svelte";

  function Capture() {
    let obj = { map };
    dispatch("capture", obj);
  }
  function file(event) {
    const selectedFile = event.target.files[0];

    const reader = new FileReader();
    reader.onload = function (event) {
      const fileContent = event.target.result;
      console.log(fileContent);
      let lines = fileContent.split("\n");
      let c = { lat: parseFloat(lines[1]), lng: parseFloat(lines[2]) };
      map = new google.maps.Map(container, {
        zoom: parseInt(lines[0]),
        center: c,
        mapTypeId: google.maps.MapTypeId.SATELLITE,
      });
      dispatch("loadMap", { map, fileContent });
    };

    reader.readAsText(selectedFile);
  }

  onMount(async () => {
    map = new google.maps.Map(container, {
      zoom,
      center,
    });
  });
</script>

<div style="display:flex;">
  <div class="full-screen" bind:this={container} />
  <div style="display:flex; flex-direction:column;">
    <button on:click={Capture}>Capture</button>
    <input
      type="file"
      name="file"
      id="fileINP"
      accept=".imp"
      on:change={file}
    />
  </div>
</div>

<style>
  .full-screen {
    width: 70vw;
    height: 70vh;
    border: 2px solid black;
    border-radius: 15px;
  }

  button {
    height: fit-content;
    align-self: center;
  }
</style>
